import Vue from 'vue'
// import Multiselect from 'vue-multiselect'
import { ToggleButton } from 'vue-js-toggle-button'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { BootstrapVue } from 'bootstrap-vue'
import appTable from '@/components/_table'
import VueTheMask from 'vue-the-mask'
import VueRecaptcha from 'vue-recaptcha'
import Vuelidate from 'vuelidate'
import VueMeta from 'vue-meta'
import appSelect from '@/components/inputs/_select'
import appSelectSearch from '@/components/inputs/_selectSearch'
// import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue-slider-component/theme/default.css'
import 'bootstrap'
import './filters'
import appUpload from '@/components/_upload'
import appHeaderRegister from '@/components/_headerRegister'
import appBodyRegister from '@/components/_bodyRegister'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import UiForm from '@/components/common/UiForm'
import UiFormGroup from '@/components/common/UiFormGroup'
import AppSelectCountry from '@/components/inputs/_selectCountry'
import AppInputCheckbox from '@/components/inputs/checkbox.vue'
import AppInputTags from '@/components/inputs/tags.vue'
import AppInputSwitch from '@/components/inputs/switch.vue'
import AppInputDatepicker from '@/components/inputs/datepicker.vue'
import {InlineSvgPlugin} from 'vue-inline-svg';
import VueUploadComponent from 'vue-upload-component'

Vue.component('VueSlider', VueSlider)
import vDatePicker from 'v-calendar/lib/components/date-picker.umd'
import 'vue-toast-notification/dist/theme-sugar.css'
import VueToast from 'vue-toast-notification'
import VueSmoothScroll from 'vue2-smooth-scroll'


Vue.use(VueSmoothScroll, {
  duration: 400,
  updateHistory: false,
  offset: -30,
})
Vue.use(VueMeta)
Vue.use(Vuelidate)
Vue.use(VueTheMask)
Vue.use(BootstrapVue)
Vue.use(VueToast)
Vue.use(InlineSvgPlugin);

Vue.component('app-table', appTable)
Vue.component('ToggleButton', ToggleButton)
// Vue.component('multiselect', Multiselect)
Vue.component('appLoading', Loading)
Vue.component('appUpload', appUpload)
Vue.component('appHeaderRegister', appHeaderRegister)
Vue.component('appBodyRegister', appBodyRegister)
Vue.component('vue-recaptcha', VueRecaptcha)
Vue.component('file-upload', VueUploadComponent)
Vue.component('ui-form', UiForm)
Vue.component('ui-form-group', UiFormGroup)

//* Inputs
Vue.component('appSelect', appSelect)
Vue.component('appSelectSearch', appSelectSearch)
Vue.component('AppInputCheckbox', AppInputCheckbox)
Vue.component('AppInputSwitch', AppInputSwitch)
Vue.component('vDatePicker', vDatePicker)
Vue.component('app-select-country', AppSelectCountry)
Vue.component('AppInputTags', AppInputTags)
Vue.component('AppInputDatepicker', AppInputDatepicker)
